import React from 'react';
import ReactDOM from 'react-dom';
import { loadDOMComponent } from '../../../helpers';
import { Provider } from 'react-redux';
import { store } from '../../../store/store';
import WizardWrapper from './WizardWrapper';
import { AppContextProvider } from '../../../Services/AppContext';
import { parseBoolean } from '../../../Utils/form.util';

loadDOMComponent({
	selector: 'react-wizard',
	callback: ({ container, context }) => {
		const wizardKey: string | null = container.getAttribute('wizardKey');
		const initialData: string | null = container.getAttribute('initialData');
		const keepInitialData: boolean = parseBoolean(
			container.getAttribute('keepInitialData'),
		);
		const keepStepsData: boolean = parseBoolean(
			container.getAttribute('keepStepsData'),
		);

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<>
						{wizardKey && (
							<WizardWrapper
								wizardKey={wizardKey}
								initialData={initialData ? JSON.parse(initialData) : undefined}
								keepInitialData={keepInitialData}
								keepStepsData={keepStepsData}
								wizardTitleStyle={{
									color: '#fff',
									fontSize: '24px',
									textAlign: 'center',
									marginBottom: '20px',
								}}
								wizardDescriptionStyle={{
									color: '#fff',
									textAlign: 'center',
									marginBottom: '20px',
								}}
							/>
						)}
					</>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
